/**
 * 区分 targetEntityType（audit_logs.target_entity_type）
 * 出典：要件書 5.2（43 テーブルの論理名。日本語は 02 6.2 の見出し）
 */
export const TARGET_ENTITY_TYPE_VALUES = [
  'users',
  'auth_codes',
  'refresh_tokens',
  'roles',
  'role_permissions',
  'customers',
  'companies',
  'sole_proprietors',
  'customer_contacts',
  'tags',
  'case_statuses',
  'cases',
  'case_items',
  'transaction_statuses',
  'transactions',
  'activities',
  'goals',
  'goal_progresses',
  'report_templates',
  'monthly_summaries',
  'personnel',
  'contracts',
  'contract_price_histories',
  'checklist_templates',
  'checklist_template_items',
  'monthly_checklists',
  'monthly_checklist_tasks',
  'forms',
  'form_versions',
  'form_notification_targets',
  'form_submissions',
  'form_replies',
  'contact_threads',
  'contact_messages',
  'attachments',
  'numbering_rules',
  'numbering_sequences',
  'system_settings',
  'audit_logs',
  'jobs',
  'import_errors',
  'unique_constraints',
  'idempotency_keys',
] as const;

export type TargetEntityType = (typeof TARGET_ENTITY_TYPE_VALUES)[number];

export const TARGET_ENTITY_TYPE_LABELS: Readonly<Record<TargetEntityType, string>> = {
  users: '利用者',
  auth_codes: '確認コード',
  refresh_tokens: 'リフレッシュトークン',
  roles: 'ロール',
  role_permissions: 'ロール権限',
  customers: '顧客',
  companies: '企業',
  sole_proprietors: '個人事業主',
  customer_contacts: '企業担当者',
  tags: 'タグ',
  case_statuses: '案件ステータス',
  cases: '案件',
  case_items: '商品明細',
  transaction_statuses: '取引ステータス',
  transactions: '取引',
  activities: '活動履歴',
  goals: '目標',
  goal_progresses: '目標進捗',
  report_templates: 'レポート雛形',
  monthly_summaries: '月次集計',
  personnel: '要員',
  contracts: '契約',
  contract_price_histories: '単価変更履歴',
  checklist_templates: 'チェックリスト雛形',
  checklist_template_items: '雛形タスク項目',
  monthly_checklists: '月次チェックリスト',
  monthly_checklist_tasks: '月次タスク',
  forms: 'フォーム',
  form_versions: 'フォームバージョン',
  form_notification_targets: 'フォーム通知先',
  form_submissions: 'フォーム回答',
  form_replies: '回答者への返信',
  contact_threads: 'コンタクト',
  contact_messages: 'メッセージ',
  attachments: '添付ファイル',
  numbering_rules: '採番ルール',
  numbering_sequences: '採番連番',
  system_settings: '自社設定',
  audit_logs: '監査ログ',
  jobs: '非同期ジョブ',
  import_errors: '取込エラー',
  unique_constraints: '一意制約',
  idempotency_keys: '冪等キー',
};
